import { debounce } from '@mui/material/utils';
import { useEffect, useState } from 'react';

export const useDebounce = (value: any, delay: number) => {
  const [debouncedValue, setDebouncedValue] = useState(value);

  const debouncedFn = debounce(() => {
    setDebouncedValue(value);
  }, delay);

  useEffect(() => {
    debouncedFn();
    return () => debouncedFn.clear();
  }, [value, delay, debouncedFn]);

  return debouncedValue;
};
